import { Theme } from "@material-ui/core/styles";
import { blackColor } from "assets/jss/app";

const companyContractStyle = (theme: Theme) => ({
  formControl: {
    // margin: theme.spacing(1),
    minWidth: "120px",
    justifyContent: "center",
    height: "100%",
  },
  inputLabel: {
    color: blackColor,
    top: "10px",
  },
});

export default companyContractStyle;
